import { render, staticRenderFns } from "./feature.vue?vue&type=template&id=50e7515f&scoped=true&"
import script from "./feature.vue?vue&type=script&lang=js&"
export * from "./feature.vue?vue&type=script&lang=js&"
import style0 from "./feature.vue?vue&type=style&index=0&id=50e7515f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e7515f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FeatureBanner: require('/var/www/mbm.garena.all/frontend/components/feature/FeatureBanner.vue').default,Class: require('/var/www/mbm.garena.all/frontend/components/Class.vue').default,Character: require('/var/www/mbm.garena.all/frontend/components/feature/Character.vue').default,Story: require('/var/www/mbm.garena.all/frontend/components/feature/Story.vue').default,Role: require('/var/www/mbm.garena.all/frontend/components/feature/Role.vue').default})
